export enum EPlateState {
  Designed = 0,
  LabelPrinted = 1,
  DispenseAttempted = 2,
  Dispensed = 3,
  Imaged = 4,
  Expired = 5,
  CrystalHarvested = 6,
}
export function GetPlateStateLabel(plateState) {
  if (plateState == EPlateState.Designed) {
    return 'Designed';
  }
  if (plateState == EPlateState.LabelPrinted) {
    return 'Label Printed';
  }
  if (plateState == EPlateState.DispenseAttempted) {
    return 'Dispense Attempted';
  }
  if (plateState == EPlateState.Dispensed) {
    return 'Dispensed';
  }
  if (plateState == EPlateState.Imaged) {
    return 'Imaged';
  }
  if (plateState == EPlateState.Expired) {
    return 'Expired';
  }
  if (plateState == EPlateState.CrystalHarvested) {
    return 'Crystal Harvested';
  }
  return '';
}
